import { useEffect, useState } from 'react'

import { motion, useMotionValue, useReducedMotion, useSpring } from 'motion/react'

import './index.scss'

let hasDrawnLogo = false
const paths = [
  { color: '#e74631', d: 'M163 20C75 20 28 89 28 208s47 188 135 188 135-69 135-188S251 20 163 20zm0 68c43 0 61 40 61 120s-18 120-61 120-61-40-61-120 18-120 61-120z' },
  { color: '#17191a', d: 'M140 4C52 4 5 73 5 192s47 188 135 188 135-69 135-188S228 4 140 4zm0 68c43 0 61 40 61 120s-18 120-61 120-61-40-61-120S97 72 140 72z' },
]

export default function Logo() {
  const reducedMotion = useReducedMotion()
  const [drawOnArrival] = useState(() => !hasDrawnLogo)
  const [canTilt, setCanTilt] = useState(false)
  const pointerX = useMotionValue(0)
  const pointerY = useMotionValue(0)
  const rotateX = useSpring(pointerX, { stiffness: 140, damping: 24, mass: 0.6 })
  const rotateY = useSpring(pointerY, { stiffness: 140, damping: 24, mass: 0.6 })

  useEffect(() => { hasDrawnLogo = true }, [])

  useEffect(() => {
    // Touch screens keep native scrolling and taps; no device-motion listeners.
    const query = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)')
    const update = () => {
      setCanTilt(query.matches && !reducedMotion)
      pointerX.set(0)
      pointerY.set(0)
    }
    update()
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [reducedMotion, pointerX, pointerY])

  const resetTilt = () => { pointerX.set(0); pointerY.set(0) }
  const followPointer = (event) => {
    if (event.pointerType !== 'mouse') return
    const bounds = event.currentTarget.getBoundingClientRect()
    const x = Math.max(-0.5, Math.min(0.5, (event.clientX - bounds.left) / bounds.width - 0.5))
    const y = Math.max(-0.5, Math.min(0.5, (event.clientY - bounds.top) / bounds.height - 0.5))
    pointerX.set(-y * 10)
    pointerY.set(x * 10)
  }
  const draw = drawOnArrival && !reducedMotion

  return (
    <div
      className="logo-container"
      onPointerMove={canTilt ? followPointer : undefined}
      onPointerLeave={canTilt ? resetTilt : undefined}
      onPointerCancel={canTilt ? resetTilt : undefined}
    >
      <motion.div className="logo-tilt" style={canTilt ? { rotateX, rotateY } : undefined}>
        <svg className="logo-artwork" viewBox="0 0 300 400" role="img" aria-label="Omar monogram">
          {paths.map(({ color, d }, index) => (
            <motion.path
              key={color}
              d={d}
              fill={color}
              stroke={color}
              strokeWidth="1.4"
              initial={draw ? { pathLength: 0, fillOpacity: 0, strokeOpacity: 1 } : false}
              animate={{ pathLength: 1, fillOpacity: 1, strokeOpacity: 0 }}
              transition={draw ? {
                pathLength: { duration: 0.85, delay: index * 0.1, ease: 'easeInOut' },
                fillOpacity: { duration: 0.35, delay: 0.8 + index * 0.1 },
                strokeOpacity: { duration: 0.25, delay: 1.05 },
              } : { duration: 0 }}
            />
          ))}
        </svg>
      </motion.div>
    </div>
  )
}
